module.exports = __webpack_public_path__ + "images/de7492b07afccab07eb3d9fc33e82ee3.svg";